import { IconProps, iconA11yProps } from '../types';

export const CloseAndMarkUnread = ({ classNames, label }: IconProps) => (
    <svg
        className={`${classNames}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeMiterlimit="10"
        strokeWidth="2"
        {...iconA11yProps(label)}
    >
        <path d="M15 10L10.0503 14.9497" />
        <path d="M10 10L14.9497 14.9497" />
        <path d="M21 10V17C21 18.1046 20.1046 19 19 19H6C4.89543 19 4 18.1046 4 17V9L1 6H17" />
        <line x1="21" y1="7" x2="21" y2="5" />
        <circle cx="21" cy="6" r="1.5" />
    </svg>
);
